import { DialogComponent } from '@theme/dialog';

/**
 * Displays an enlarged, landscape view of a tailgate design already in the cart.
 * Triggered via `on:click="#ct-enlarge-dialog/open"` on a cart line item's design
 * thumbnail (see snippets/cart-products.liquid).
 *
 * @extends DialogComponent
 */
class CartDesignEnlargeDialog extends DialogComponent {
  /**
   * @param {PointerEvent} event
   */
  open(event) {
    event.preventDefault();

    if (!(event.target instanceof HTMLElement)) return;
    const url = event.target.dataset.designUrl;

    // An SVG <image> inside the framing svg (snippets/cart-design-preview.liquid):
    // it takes href, not src, and doesn't respond to the hidden property.
    const img = this.querySelector('#ct-enlarge-img');
    if (img) {
      if (url) {
        img.classList.remove('is-empty');
        img.setAttribute('href', url);
      } else {
        // Matte White has no uploaded design — show just the outline.
        img.classList.add('is-empty');
        img.removeAttribute('href');
      }
    }

    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    const isPortrait = window.innerHeight > window.innerWidth;

    // The rotate hint lives *inside* the dialog (rather than a separate
    // fixed-position overlay) so it stays in the same top-layer stacking
    // context — a plain overlay would render behind an already-open cart
    // drawer, which also uses showModal(). It's shown fully opaque *before*
    // the dialog's first paint so there's no flash of the real (still
    // sideways) content underneath.
    const hint = isTouchDevice && isPortrait ? this.querySelector('#ct-rotate-hint-cart') : null;
    if (hint) hint.classList.add('is-active', 'is-visible');

    this.showDialog();

    if (hint) {
      setTimeout(() => {
        hint.classList.remove('is-visible');
        setTimeout(() => hint.classList.remove('is-active'), 250);
      }, 1800);
    }
  }
}

if (!customElements.get('ct-enlarge-dialog')) {
  customElements.define('ct-enlarge-dialog', CartDesignEnlargeDialog);
}
